import api from './api';

/**
 * Login admin
 */
export const login = async (email, password) => {
    try {
        const response = await api.post('/admin/login', { email, password });
        
        if (response.data.success) {
            localStorage.setItem('adminToken', response.data.token);
            localStorage.setItem('adminEmail', response.data.admin.email);
            return {
                success: true,
                admin: response.data.admin
            };
        }
        
        return {
            success: false,
            message: response.data.message || 'Login failed'
        };
    } catch (error) {
        return {
            success: false,
            message: error.response?.data?.message || 'Login failed. Please try again.'
        };
    }
};

/**
 * Logout admin
 */
export const logout = async () => {
    try {
        await api.post('/admin/logout');
    } catch (error) {
        console.error('Logout error:', error);
    } finally {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminEmail');
    }
};

/**
 * Verify token
 */
export const verifyToken = async () => {
    try {
        const response = await api.get('/admin/verify');
        return response.data.success;
    } catch (error) {
        return false;
    }
};

/**
 * Check if admin is authenticated
 */
export const isAuthenticated = () => {
    return !!localStorage.getItem('adminToken');
};

/**
 * Get admin email from storage
 */
export const getAdminEmail = () => {
    return localStorage.getItem('adminEmail');
};
